import { Parent } from "./parent"
export class Legend extends Parent {
  constructor(options) {
    super()
    this.type = this.getAndSetPrimaryVal(options, "type", "plain")
    this.show = this.getAndSetPrimaryVal(options, "show", true)
    this.left = this.getAndSetPrimaryVal(options, "left", "auto")
    this.top = this.getAndSetPrimaryVal(options, "top", "auto")
    this.right = this.getAndSetPrimaryVal(options, "right", "auto")
    this.bottom = this.getAndSetPrimaryVal(options, "bottom", "auto")
    this.width = this.getAndSetPrimaryVal(options, "width", "auto")
    this.height = this.getAndSetPrimaryVal(options, "height", "auto")
    this.orient = this.getAndSetPrimaryVal(options, "orient", "horizontal")
    this.align = this.getAndSetPrimaryVal(options, "align", "auto")
    this.padding = this.getAndSetPrimaryVal(options, " padding", 5)
    this.itemGap = this.getAndSetPrimaryVal(options, "itemGap", 10)
    this.itemWidth = this.getAndSetPrimaryVal(options, "itemWidth", 25)
    this.itemHeight = this.getAndSetPrimaryVal(options, "itemHeight", 14)
    this.itemStyle = this.getAndSetPrimaryVal(options, "itemStyle", {})
    this.textStyle = this.getAndSetPrimaryVal(options, "textStyle", {})
    this.itemGap = this.getAndSetPrimaryVal(options, "itemGap", 10)
    this.padding = this.getAndSetPrimaryVal(options, "padding", [0, 0, 0, 0])
    if (options.data) {
      this.data = options.data
    }
    this.initNoPrimaryValOption(options)
  }
  initNoPrimaryValOption(opt) {
    const k = ["formatter", "icon", "borderRadius"]
    k.forEach(key => {
      if (this.hasVal(opt, key)) {
        this[key] = opt[key]
      }
    })
  }
  checkArgs(args) {
    const argNameArr = Tooltip.toString()
      .match(/\((.+?)\)/g)[0]
      .slice(1, -1)
      .replace(/\s+/g, "")
      .split(",")
    for (let i = 0; i < argNameArr.length; i++) {
      if (typeof args[i] === "undefined") {
        throw new Error(
          "the argument '" + argNameArr[i] + "' from class tooltip is undefined,please check this argument"
        )
      }
    }
  }
}
